import React from 'react'
import { Lock } from 'lucide-react'

/**
 * Shown when a non-super user navigates to the admin route.
 */
export const AccessDenied = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 text-center">
      <Lock size={48} className="text-gray-400" />
      <h1 className="text-2xl font-semibold text-darkBlue">Access denied</h1>
      <p className="max-w-md text-gray-500">
        You don't have permission to view this page. The admin panel is only
        available to Purposely super users.
      </p>
    </div>
  )
}

export default AccessDenied
